/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import classNames from 'classnames';
import randomId from 'javascripts/utils/random-id';
import Picture from 'components/atoms/picture/react/Picture';
import type { PictureType } from 'components/atoms/picture/react/Picture';
import Icon from 'components/_particles/icon/react/Icon';
import IconLink from 'components/atoms/icon-link/react/IconLink';
import MediaButton from 'components/atoms/media-button/react/MediaButton';
import type { MediaButtonType } from '../../../atoms/media-button/react/MediaButton';

export type CopyrightType = {
  icon?: string,
  text?: string,
};

export type Props = {
  id?: string,
  tag?: string,
  ariaLabelledby?: string,
  className?: string,
  cookie?: string,
  picture?: PictureType,
  link?: {
    text?: string,
    link?: string,
    icon?: string,
  },
  mediaType?: MediaButtonType,
  copyright?: CopyrightType,
  caption?: string,
  description?: string,
};

export const Copyright = ({
  icon,
  text,
}: CopyrightType): React$MixedElement => {
  return (
    <div className="copyright">
      {icon && <Icon icon={icon} className="copyright__icon" />}
      <span className="copyright__text">{text}</span>
    </div>
  );
};

const Figure = ({
  id,
  ariaLabelledby,
  className,
  cookie,
  picture,
  link,
  mediaType,
  copyright,
  caption,
  description,
}: Props): React$MixedElement => {
  const labelId = id ? `${id}-label` : `figure-${randomId()}-label`;

  const Tag = ({ children, attr }: { children: any, attr?: any }) =>
    picture?.src ? (
      <figure {...attr}>{children}</figure>
    ) : (
      <div {...attr}>{children}</div>
    );

  return (
    <Tag
      attr={{
        ' aria-labelledby': caption ? labelId : undefined,
        className: classNames('figure', className),
        'data-cookie': cookie,
      }}
    >
      {picture && (
        <div className="figure__media">
          {mediaType ? (
            <div className="figure__image-media">
              {picture.src && <Picture {...picture} />}
              <MediaButton {...mediaType} className="figure__image-button" />
            </div>
          ) : (
            picture.src && <Picture {...picture} />
          )}

          {copyright && (
            <div className="figure__copyright">
              <Copyright {...copyright} />
            </div>
          )}
          {link && (
            <div className="figure__linkbadge">
              <Icon icon={link.icon || 'camera'} />
            </div>
          )}
        </div>
      )}

      {caption && (
        <figcaption className="figure__caption" id={labelId}>
          {caption}

          {description && <div className="figure__text">{description}</div>}
        </figcaption>
      )}
    </Tag>
  );
};

export default Figure;
